import _ from 'lodash';

export function calculateDepreciationRatio({
  effectiveAge = 0,
  totalEconomicLife,
}: {
  effectiveAge?: number;
  totalEconomicLife: number;
}) {
  const result = totalEconomicLife === 0 ? 0 : effectiveAge / totalEconomicLife;
  return _.round(result, 3); // Keep 1 decimal in percentage (e.g. 63.7%) so what we show in UI is what's used in calculations
}
